import PropTypes from 'prop-types';
import { FormattedMessage, useIntl } from 'react-intl';
import { useHistory } from 'react-router-dom';

import { get } from 'utils/lodash';
import { routes } from 'router/routes';

import { BasicDrawer } from 'components/common/drawers';
import { ActionButton } from 'components/common/buttons';

import { MBI_CORPORATE_WEBSITE } from 'settings/constants/common';
import { useContext, useEffect } from 'react';
import isEmpty from 'lodash/isEmpty';
import { LocaleContext } from '../../providers/context';

const LoginFeedbackDrawer = ({
  isDrawerOpen,
  isDrawerOpenFc,
  drawerType,
  drawerMessage,
  handleChange,
  selfUnlock,
  isRedirectMainSite,
  formChangePassword,
}) => {
  const history = useHistory();

  const { formatMessage } = useIntl();

  const loginPath = get(routes, 'login', '/login');
  const { locale, setLocale } = useContext(LocaleContext);
  const languageFromStorage = localStorage.getItem('language');
  const languageLocalStorage =
    !languageFromStorage || isEmpty(languageFromStorage.replace(/"/g, '')) ? locale : languageFromStorage.replace(/"/g, '');

  const handleOnClick = () => {
    setLocale(!isEmpty(languageLocalStorage) ? languageLocalStorage : locale);
    if (formChangePassword) handleChange('isDrawerOpenFc', false);
    else handleChange('isDrawerOpen', false);

    history.push(loginPath);
  };

  const handleOnClose = () => {
    setLocale(!isEmpty(languageLocalStorage) ? languageLocalStorage : locale);
    if (formChangePassword) handleChange('isDrawerOpenFc', !isDrawerOpenFc);
    else handleChange('isDrawerOpen', !isDrawerOpen);

    if (isRedirectMainSite) window.location.replace(MBI_CORPORATE_WEBSITE);
  };

  useEffect(() => {
    setLocale(!isEmpty(languageLocalStorage) ? languageLocalStorage : locale);
  }, []);
  return (
    <BasicDrawer
      className={drawerType}
      isOpen={formChangePassword ? isDrawerOpenFc : isDrawerOpen}
      hideBackdrop={false}
      onClose={handleOnClose}
    >
      {selfUnlock ? (
        <div className="feedback-drawer--container">
          <h1 className="f5 lh-copy">{drawerMessage}</h1>
          <ActionButton
            isAssetIcon={false}
            title={formChangePassword ? formatMessage({ id: 'buttonText.loginFc' }) : formatMessage({ id: 'buttonText.login' })}
            icon="arrowForward"
            className="db"
            onClick={handleOnClick}
          />
        </div>
      ) : (
        <h1 className="f5 lh-copy tc white">{drawerMessage}</h1>
      )}
    </BasicDrawer>
  );
};

LoginFeedbackDrawer.defaultProps = { isDrawerOpenFc: false, isRedirectMainSite: false, formChangePassword: false };

LoginFeedbackDrawer.propTypes = {
  isDrawerOpen: PropTypes.bool.isRequired,
  isDrawerOpenFc: PropTypes.bool,
  drawerType: PropTypes.string.isRequired,
  drawerMessage: PropTypes.string.isRequired,
  handleChange: PropTypes.func.isRequired,
  selfUnlock: PropTypes.bool.isRequired,
  isRedirectMainSite: PropTypes.bool,
  formChangePassword: PropTypes.bool,
};

export default LoginFeedbackDrawer;
